import AprovadoresRotas from './aprovadores/AprovadoresRotas'
import financeiroRotas from './financeiro/FinanceiroRotas'
import gestoresRotas from './gestores/GestoresRotas'
import gerentesRotas from './gerentes/GerentesRotas'
import fornecedoresRotas from './fornecedores/FornecedoresRotas'
import uabsRotas from './uabs/UabsRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import relatoriosConveniosRotas from './relatoriosconvenios/ConveniosRelatoriosRotas'
import relatoriosCotratosRotas from './relatorioscontratos/ContratosRelatoriosRotas'
import conveniosFornecedoresRotas from './convenios/fornecedor/FornecedoresRotas'
import conveniosGestoresRotas from './convenios/gestor/GestoresRotas'
import conveniosFinanceiroRotas from './convenios/financeiro/FinanceiroRotas'
import requisicoesRotas from './contratos/requisicoes/RequisicoesRotas'

export default {
    path: 'gescon',
    name: 'Gescon',
    component: {
        render(c) {
            return c('router-view')
        }
    },

    children: [
        AprovadoresRotas,
        financeiroRotas,
        conveniosFornecedoresRotas,
        gestoresRotas,
        gerentesRotas,
        fornecedoresRotas,
        uabsRotas,
        apoiosRotas,
        relatoriosConveniosRotas,
        relatoriosCotratosRotas,
        conveniosGestoresRotas,
        conveniosFinanceiroRotas,
        requisicoesRotas
    ]
}